import { http } from './HttpService.js'
import axios from 'axios';

export default {
	load(params = '') {
		return http.get('fornecedores' + params)
	},
	update(data) {
		let params = data.codigo
		return http.post('fornecedores/' + params, data)
	},
	create(data) {
		return http.post('fornecedores/create', data)
	},
	destroy(codigo) {
		return http.delete('fornecedores/' + codigo)
	},
	carregarCep(cep){
		return axios.create({
        	baseURL: 'https://viacep.com.br/ws/' + cep + '/json/'
		}).get()
	}
}